/* eslint-disable react-hooks/exhaustive-deps */
import { useApolloClient } from "@apollo/client";
import Button from "@mostrans/web-components/components/base/Button";
import { Card, CardContent, CircularProgress, Container } from "@mui/material";
import { Box } from "@mui/system";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { useHistory } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { addCandidateToOpportunity } from "../../graphql/mutations";
import {
  getCandidateByID,
  getOpportunitiesByCandidateID,
  getOpportunityByID,
  getOpportunityIsActive
} from "../../graphql/query";
import { getOpportunityByCandidateID } from "../../shared/atom/detailCandidate";
import { isLoggedInSelector, userDataSelector } from "../../shared/globalStates";
import { toastError, toastSuccess } from "../../shared/helpers";
import { useValidateUser } from "../../shared/hooks/useValidateUser";
import "./CardDetail.css";

const CardDetail = ({ id, setOpen, setdata }) => {
  const validate = useValidateUser();
  const isLoggedIn = useRecoilValue(isLoggedInSelector);
  const userData = useRecoilValue(userDataSelector);
  const [isAuth, setIsAuth] = useState(false);
  const [dataCandidate, setDataCandidate] = useState()
  const client = useApolloClient();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [listApply, setListApply] = useRecoilState(getOpportunityByCandidateID);

  useEffect(() => {
    getCandidateByID(client).then(setDataCandidate);
  }, []);

  useEffect(() => {
    getOpportunityByID(client, id).then(setData);
    if (isAuth) {
      if (isEmpty(listApply)) {
        getOpportunitiesByCandidateID(client).then(setListApply);
      }
    }
    validate.then(setIsAuth);
  }, [listApply]);

  useEffect(() => {
    if (!isEmpty(data)) {
      setLoading(false);
    }
  }, [data]);

  const handleClick = async () => {
    if (isAuth === true) {
      if (!dataCandidate?.curr_benefits &&
        dataCandidate?.curr_salary === 0) {
        return toastError("Current Salary and benefit information is required");
      }
      if (!dataCandidate?.expected_benefits &&
        dataCandidate?.expected_salary === 0) {
        history.push("/career/home");
        return toastError("Expected Salary and benefit information is required");
      }
      if (listApply.find((e) => e.id === data.id)) {
        toastError("Error, you have already applied for this job");
        setOpen(false);
      } else {
        const add = await addCandidateToOpportunity(client, data.id);
        if (add.status !== "000") {
          toastError("Error, try again later");
          setOpen(false);
        } else {
          toastSuccess("Success, Apply job successfully");
          if (isLoggedIn) {
            const refetch = await getOpportunityIsActive(client, parseInt(userData.id));
            setdata(refetch);
          }
          setOpen(false);
        }
      }
    } else {
      history.push({ pathname: `/application-form`, state: { id: data.id } });
    }
  };

  return (
    <Container maxWidth="md" style={{ padding: "0" }}>
      <Card variant="outlined" className="bg-white">
        {loading ? (
          <Box
            sx={{
              margin: "auto",
              justifyContent: "center",
              textAlign: "center",
            }}>
            <CircularProgress />
          </Box>
        ) : (
          <CardContent style={{ padding: "0" }}>
            <div className="header-cardDetail">
              <div className="header-title d-flex justify-content-between">
                <h2 className="text-primary-main">{data.title}</h2>
                <div
                  className="bg-neutral-n2-hover text-center d-flex"
                  onClick={() => setOpen(false)}
                  style={{
                    margin: "auto 0",
                    borderRadius: "50px",
                    cursor: "pointer",
                    height: "50px",
                    width: "50px",
                  }}>
                  <span className="material-icons m-auto"> close </span>
                </div>
              </div>
              <div className="sub-header d-inline-flex">
                <div className="pr-2">
                  <span className="sub-icon-details material-icons text-primary-main">work</span>
                  {data.Division.division}
                </div>
                <div className="pr-2">
                  <span className="sub-icon-details material-icons text-primary-main">badge</span>
                  {data.job_level}
                </div>
                <div className="pr-2">
                  <span className="sub-icon-details material-icons text-primary-main">
                    location_on
                  </span>
                  {data.Location.nama}
                </div>
              </div>
            </div>
            <hr style={{ margin: "10px 0", width: "100%" }} />
            <div className="body-cardDetail">
              <div className="font-size-h5">
                <h4>Description</h4>
                {/* <div
                  className="wrapper_description"
                  dangerouslySetInnerHTML={{ __html: data.description }}
                /> */}

                <div style={{ fontSize: "40px" }}>
                  <ReactQuill
                    readOnly
                    value={data.description || "-"}
                    theme="bubble"
                  />
                </div>
                <h4>Requirements</h4>
                <div className="text-requirements">
                  <ul>
                    {data.Requirement
                      ? data.Requirement.map((result) => (
                        <li
                          // className="text-textSecondary"
                          key={result.id}
                          style={{ listStyleType: "disc", margin: "0 15px" , fontSize: "13px" }}>
                          {result.job_requirement}
                        </li>
                      ))
                      : "No Job Requirement"}
                  </ul>
                </div>
                {/* <h4>Jobs Description</h4>
                <div className="text-jobs-description">
                  <ul>
                    {data.JobDesc
                      ? data.JobDesc.map((result) => (
                          <li
                            className="text-textSecondary"
                            key={result.id}
                            style={{ listStyleType: "disc", margin: "0 15px" }}>
                            {result.job_description}
                          </li>
                        ))
                      : "No Job Description"}
                  </ul>
                </div> */}
                {/* <h4>Qualifications</h4>
                <div className="text-qualifications">
                  <ul>
                  {data.content[0].qualify.map((result, index) => (
                    <li
                      className="text-textSecondary"
                      key={index}
                      style={{ listStyleType: "disc", margin: "0 15px" }}>
                      {result}
                    </li>
                  ))}
                </ul>
                </div>
                <h4>Skills</h4>
                <div className="skills">
                  {data.content[0].skills.map((result, index) => (
                  <div
                    className="d-inline-flex border bg-neutral-n2 tag-skills"
                    key={index}>
                    {result}
                  </div>
                ))}
                </div> */}
              </div>
            </div>
            <hr style={{ width: "100%" }} />
            <div
              className="footer-cardDetail"
              style={{
                cursor: listApply.find((e) => e.id === data.id) && "no-drop",
                padding: "1rem",
                position: "sticky"
              }}>
              <Button
                onClick={handleClick}
                color="primary"
                variant="contained"
                disabled={listApply.find((e) => e.id === data.id)}
                className={`text-center`}
                style={{
                  borderRadius: "10px",
                  width: "100%",
                  backgroundColor: listApply.find((e) => e.id === data.id) && "rgb(198, 198, 198)",
                  padding: "1rem",
                }}>
                <h6 className="text-white" style={{ verticalAlign: "text-bottom", width: "100%" }}>
                  {listApply.find((e) => e.id === data.id) ? "Anda Sudah Melamar" : "Apply Now"}
                </h6>
              </Button>
            </div>
          </CardContent>
        )}
      </Card>
    </Container>
  );
};

export default CardDetail;
